import { render, staticRenderFns } from "./emptyPage.vue?vue&type=template&id=fe39dd04&"
import script from "./emptyPage.vue?vue&type=script&lang=js&"
export * from "./emptyPage.vue?vue&type=script&lang=js&"
import style0 from "./emptyPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports